import React, { createContext, useContext, useState, useEffect } from 'react';

const SchemaContext = createContext();

export const useSchema = () => useContext(SchemaContext);

const globalSchemas = [
  {
    "@type": "Organization",
    "@id": "https://www.omkarresearchanalyst.in/#organization",
    "name": "Omkar Research Analyst",
    "url": "https://www.omkarresearchanalyst.in/",
    "logo": "https://www.omkarresearchanalyst.in/logo3.png",
    "description": "SEBI Registered Research Analyst offering expert investment advice and research.",
    "sameAs": [
      "https://www.facebook.com/omkarresearchanalyst",
      "https://www.linkedin.com/in/jignesh-patel-omkar-research-analyst/",
      "https://www.youtube.com/@omkarresearchanalyst",
      "https://t.me/omkarresearchanalyst1"
    ],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "5/2 Chitraami Apartment, Opp Old RBI, Ashram Road",
      "addressLocality": "Ahmedabad",
      "addressRegion": "Gujarat",
      "postalCode": "380009",
      "addressCountry": "IN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-9898001671",
      "contactType": "customer service"
    }
  },
  {
    "@type": "Person",
    "@id": "https://www.omkarresearchanalyst.in/about#jigneshpatel",
    "name": "Jignesh Patel",
    "url": "https://www.omkarresearchanalyst.in/about",
    "jobTitle": "SEBI Registered Research Analyst (INH000021359)",
    "alumniOf": "National Institute of Securities Markets (NISM)",
    "hasCredential": {
      "@type": "EducationalOccupationalCredential",
      "credentialCategory": "NISM Certified"
    },
    "worksFor": {
      "@type": "Organization",
      "name": "Omkar Research Analyst"
    },
    "knowsAbout": ["Equity Market Research", "Commodity Trading", "Stock Options", "Technical Analysis"]
  }
];

export const SchemaProvider = ({ children }) => {
  // Registry mapped to types/IDs to allow hydration of static placeholders
  const [schemaRegistry, setSchemaRegistry] = useState({
    global: globalSchemas,
    blog: null,
    faq: null,
    breadcrumb: null
  });

  const setLocalSchemas = (schemas) => {
    // schemas is an array from BlogSchema
    const newRegistry = { ...schemaRegistry };
    newRegistry.blog = schemas.find(s => s["@type"] === "BlogPosting") || null;
    newRegistry.faq = schemas.find(s => s["@type"] === "FAQPage") || null;
    newRegistry.breadcrumb = schemas.find(s => s["@type"] === "BreadcrumbList") || null;
    setSchemaRegistry(newRegistry);
  };

  const value = {
    setLocalSchemas,
  };

  useEffect(() => {
    // Combine all segments from the registry into one flat graph
    const allSegments = Object.values(schemaRegistry).flat().filter(Boolean);
    
    const combinedGraph = {
      "@context": "https://schema.org",
      "@graph": allSegments
    };

    console.log('[SchemaRegistry] Syncing v1.1.2 graph. Total items:', allSegments.length);

    // Remove existing script so validators detect the change
    let oldScript = document.getElementById('omkar-unified-schema');
    if (oldScript) {
      oldScript.remove();
    }

    // Create a new unified script tag
    const script = document.createElement('script');
    script.id = 'omkar-unified-schema';
    script.type = 'application/ld+json';
    script.text = JSON.stringify(combinedGraph);
    document.head.appendChild(script);
  }, [schemaRegistry]);

  return (
    <SchemaContext.Provider value={value}>
      {children}
    </SchemaContext.Provider>
  );
};
